import styled from '@emotion/styled';
import { theme } from 'styles/theme/theme';

export const Header = styled.div`
  height: 14px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  gap: 14px;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const LegendColor = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;

  &.shading {
    border: 1px solid ${({ theme }) => theme.colors.WhiteGray};
  }

  &.primary {
    background-color: ${({ theme }) => theme.colors.DarkYellow};
  }

  &.secondary {
    background-color: ${({ theme }) => theme.colors.WhiteGray20};
  }
`;

export const CountMarker = styled.div`
  top: 0;
  display: flex;
  flex-direction: row;

  p {
    margin-left: 4.5px;
  }
`;

export const DashedLine = styled.div`
  height: 36px;
  border-left: 1px dashed #9093aa66;
`;

export const MainBlock = styled.div`
  display: flex;
  overflow: hidden;
  border-radius: 4px;

  gap: 2px;
`;

export const Block = styled.div`
  height: 24px;
  border-radius: 4px;
  min-width: 30px;

  &.shading {
    background-image: repeating-linear-gradient(
      135deg,
      ${({ theme }) => theme.colors.WhiteGray60},
      ${({ theme }) => theme.colors.WhiteGray60} 2px,
      transparent 2px,
      transparent 7px
    );
    border: 0.5px solid ${theme.colors.WhiteGray10};
  }

  &.primary {
    background-color: ${({ theme }) => theme.colors.DarkYellow};
  }

  &.secondary {
    background-color: ${({ theme }) => theme.colors.WhiteGray20};
  }
`;
